// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './YoutubeIcon.style';

export class YoutubeIcon extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    render() {
        return (
            <svg width="32" height="35" viewBox="0 0 32 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1138_674)">
                    <path d="M31.3332 9.53517C31.152 8.84842 30.799 8.22666 30.3118 7.736C29.8109 7.23026 29.1969 6.86849 28.5278 6.68484C26.0238 5.98359 15.9918 5.98359 15.9918 5.98359C11.8096 5.93303 7.62842 6.15539 3.47185 6.64942C2.80277 6.84664 2.18993 7.21649 1.68785 7.72609C1.19451 8.23042 0.83718 8.85234 0.650513 9.53375C0.202104 12.1004 -0.0157643 14.7065 -0.000153652 17.3169C-0.0161537 19.925 0.20118 22.5303 0.650513 25.1001C0.83318 25.7787 1.18918 26.3978 1.68385 26.8978C2.17851 27.3979 2.79451 27.7592 3.47185 27.9504C6.00918 28.6503 15.9918 28.6503 15.9918 28.6503C20.1794 28.7009 24.3659 28.4785 28.5278 27.9844C29.1969 27.8008 29.8109 27.439 30.3118 26.9333C30.7989 26.4427 31.1514 25.8209 31.3318 25.1341C31.792 22.5684 32.0157 19.9613 31.9998 17.3495C32.0345 14.7267 31.811 12.1072 31.3332 9.53375V9.53517ZM12.8025 22.1676V12.4677L21.1492 17.3183L12.8025 22.1676Z" fill="#FDF8F4" />
                </g>
                <defs>
                    <clipPath id="clip0_1138_674">
                        <rect width="32" height="34" fill="white" transform="translate(0 0.316406)" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default YoutubeIcon;
